webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(84),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(92),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(80),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(88),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(78),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_smooth_scroll__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_plugin_load_script__ = __webpack_require__(95);







(function () {
  window.Portfolio = window.Portfolio || {};

  window.Portfolio.Vue = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */];
  window.Portfolio.Vue.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
  window.Portfolio.Vue.use(__WEBPACK_IMPORTED_MODULE_2_vue_smooth_scroll___default.a);
  window.Portfolio.Vue.use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
  window.Portfolio.Vue.use(__WEBPACK_IMPORTED_MODULE_4_vue_plugin_load_script__["a" /* default */]);
})();

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_partials_landing_Landing__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_partials_landing_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_partials_landing_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_partials_styleguide_Styles__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_partials_styleguide_Styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_partials_styleguide_Styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_partials_testimonials_Testimonials__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_partials_testimonials_Testimonials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_partials_testimonials_Testimonials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_partials_tableau_Tableau__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_partials_tableau_Tableau___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_partials_tableau_Tableau__);





var router = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Landing',
    component: __WEBPACK_IMPORTED_MODULE_1__views_partials_landing_Landing___default.a
  }, {
    path: '/styleguide',
    name: 'Styles',
    component: __WEBPACK_IMPORTED_MODULE_2__views_partials_styleguide_Styles___default.a
  }, {
    path: '/testimonials',
    name: 'Testimonials',
    component: __WEBPACK_IMPORTED_MODULE_3__views_partials_testimonials_Testimonials___default.a
  }, {
    path: '/tableau',
    name: 'Tableau',
    component: __WEBPACK_IMPORTED_MODULE_4__views_partials_tableau_Tableau___default.a
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(86),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootMeUp__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Layout_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Layout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Layout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_anchor_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_anchor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_anchor_js__);







var anchors = new __WEBPACK_IMPORTED_MODULE_3_anchor_js___default.a({
  placement: 'left',
  icon: '#',
  visible: 'hover'
});
var sources = {
  'examples': {
    'name': 'Layout Example Data',
    'id': 'one',
    'path': '/static/data/examples.json'
  },
  'projects': {
    'name': 'Project Data',
    'id': 'two',
    'path': '/static/data/projects.json'
  }
};

new window.Portfolio.Vue({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */],
  template: '<layout-view></layout-view>',
  components: {
    'layout-view': __WEBPACK_IMPORTED_MODULE_2__views_Layout_vue___default.a
  },
  data: {
    activeSource: '',
    sources: sources,
    items: []
  },
  methods: {
    anchorsInit: function anchorsInit() {
      return anchors;
    },
    getAvailableDataSources: function getAvailableDataSources() {
      return this.sources;
    },
    getItems: function getItems() {
      return this.items;
    },
    getActiveDataSource: function getActiveDataSource() {
      return this.activeSource;
    },
    setActiveDataSource: function setActiveDataSource(key) {
      var _this = this;

      this.activeSource = key;

      this.$http.get(this.sources[this.activeSource].path).then(function (response) {

        _this.items.splice(0);

        response.data.items.forEach(function (item) {
          _this.items.push(item);
        });
      });
    }
  },
  created: function created() {
    this.setActiveDataSource('projects');
  },
  mounted: function mounted() {
    this.anchorsInit();
    anchors.add('.anchor');
    console.log(anchors);
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_app_footer_AppFooter_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_app_footer_AppFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_app_footer_AppFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_app_nav_AppNav_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_app_nav_AppNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_app_nav_AppNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hero_Hero_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hero_Hero_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_hero_Hero_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layout-view',
  components: {
    'app-footer': __WEBPACK_IMPORTED_MODULE_0__partials_app_footer_AppFooter_vue___default.a,
    'app-navigation': __WEBPACK_IMPORTED_MODULE_1__partials_app_nav_AppNav_vue___default.a,
    'hero': __WEBPACK_IMPORTED_MODULE_2__components_hero_Hero_vue___default.a
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'colors',
  data: function data() {
    return {
      "colorVars": [{
        "name": "white",
        "var": "$white",
        "invert": "$white-invert"
      }, {
        "name": "black",
        "var": "$black",
        "invert": "$white"
      }, {
        "name": "light",
        "var": "$light",
        "invert": "$light-invert"
      }, {
        "name": "dark",
        "var": "$dark",
        "invert": "$dark-invert"
      }, {
        "name": "primary",
        "var": "$primary",
        "invert": "$primary-invert"
      }, {
        "name": "info",
        "var": "$info",
        "invert": "$info-invert"
      }, {
        "name": "success",
        "var": "$success",
        "invert": "$success-invert"
      }, {
        "name": "warning",
        "var": "$warning",
        "invert": "$warning-invert"
      }, {
        "name": "danger",
        "var": "$danger",
        "invert": "$danger-invert"
      }, {
        "name": "blue",
        "var": "$blue",
        "invert": "$blue-invert"
      }, {
        "name": "blue-background",
        "var": "$blue-background",
        "invert": "$grey"
      }, {
        "name": "pink",
        "var": "$pink",
        "invert": "$pink-invert"
      }, {
        "name": "orange",
        "var": "$orange",
        "invert": "$orange-invert"
      }, {
        "name": "yellow",
        "var": "$yellow",
        "invert": "$yellow-invert"
      }, {
        "name": "green",
        "var": "$green",
        "invert": "$green-invert"
      }, {
        "name": "purple",
        "var": "$purple",
        "invert": "$purple-invert"
      }, {
        "name": "turquoise",
        "var": "$turquoise",
        "invert": "$turquoise-invert"
      }, {
        "name": "red",
        "var": "$red",
        "invert": "$red-invert"
      }]
    };
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
var options = {
  inputClasses: {
    valid: 'is-success',
    invalid: 'is-danger'
  }
};


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  mixins: [new __WEBPACK_IMPORTED_MODULE_0_vue_form___default.a(options)],
  data: function data() {
    return {
      formstate: {},
      finished: false,
      model: {
        name: '',
        _replyto: '',
        message: '',
        _subject: 'You\'ve Got Mail!'
      }
    };
  },

  methods: {
    fieldClassName: function fieldClassName(field) {
      if (!field) {
        return '';
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'has-success';
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-danger';
      }
    },
    onSubmit: function onSubmit() {
      var host = 'https://formspree.io/leslie@catapultwebdevelopment.com';
      if (this.formstate.$invalid) {
        console.log('uhoh');
      } else {
        var postData = this.model;
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
          url: host,
          method: "POST",
          data: postData,
          dataType: "json",
          success: function (data) {
            this.finished = true;
          }.bind(this),
          error: function error(err) {
            console.log('reply error ' + err);
          },
          complete: function complete(jqXHR, status) {}
        });
      }
    }
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'grid',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hero',
  props: ['heroClass', 'heroMsg'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project-item-description-item',
  props: ['id', 'content', 'label'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project-macbook',
  props: ['id', 'image', 'name'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project-tablet',
  props: ['id', 'image', 'name'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project-testimonial',
  props: ['id', 'link', 'quote', 'name', 'role', 'image'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'select-source',
  props: ['activeSource', 'sources'],
  methods: {
    sourceChanged: function sourceChanged(e) {
      this.$emit('source-changed', e.target.value);
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-footer',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'appNav'
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_partials_project_items_ProjectItems__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_partials_project_items_ProjectItems___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_partials_project_items_ProjectItems__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  components: {
    'project-items': __WEBPACK_IMPORTED_MODULE_0__views_partials_project_items_ProjectItems___default.a
  },
  data: function data() {
    return {
      projects: this.$root.getItems()
    };
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_project_item_description_item_ProjectItemDescriptionItem__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_project_item_description_item_ProjectItemDescriptionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_project_item_description_item_ProjectItemDescriptionItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_project_testimonial_ProjectTestimonial__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_project_testimonial_ProjectTestimonial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_project_testimonial_ProjectTestimonial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_project_tablet_ProjectTablet__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_project_tablet_ProjectTablet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_project_tablet_ProjectTablet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_macbook_ProjectMacbook__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_macbook_ProjectMacbook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_project_macbook_ProjectMacbook__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project-item',
  components: {
    "project-item-description-item": __WEBPACK_IMPORTED_MODULE_0__components_project_item_description_item_ProjectItemDescriptionItem___default.a,
    "project-testimonial": __WEBPACK_IMPORTED_MODULE_1__components_project_testimonial_ProjectTestimonial___default.a,
    "project-tablet": __WEBPACK_IMPORTED_MODULE_2__components_project_tablet_ProjectTablet___default.a,
    "project-macbook": __WEBPACK_IMPORTED_MODULE_3__components_project_macbook_ProjectMacbook___default.a
  },
  props: ['project']
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_partials_project_item_ProjectItem__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_partials_project_item_ProjectItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_partials_project_item_ProjectItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_anchor_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_anchor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_anchor_js__);



var project_anchors = new __WEBPACK_IMPORTED_MODULE_1_anchor_js___default.a({
  placement: 'left',
  icon: '#',
  visible: 'hover'
});
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project-items',
  components: {
    "project-item": __WEBPACK_IMPORTED_MODULE_0__views_partials_project_item_ProjectItem___default.a
  },
  props: ['projects'],
  methods: {
    anchorsInit: function anchorsInit() {
      return project_anchors;
    }
  },
  mounted: function mounted() {
    this.anchorsInit();
    project_anchors.add('.project_anchor');
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_partials_project_items_ProjectItems__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_partials_project_items_ProjectItems___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_partials_project_items_ProjectItems__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_grid_Grid__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_grid_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_grid_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hero_Hero__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hero_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_hero_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_tablet_ProjectTablet__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_project_tablet_ProjectTablet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_project_tablet_ProjectTablet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_project_macbook_ProjectMacbook__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_project_macbook_ProjectMacbook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_project_macbook_ProjectMacbook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contact_Contact__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contact_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_contact_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_select_source_SelectSource__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_select_source_SelectSource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_select_source_SelectSource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_colors_Colors__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_colors_Colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_colors_Colors__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'styles',
  components: {
    "project-items": __WEBPACK_IMPORTED_MODULE_0__views_partials_project_items_ProjectItems___default.a,
    "grid": __WEBPACK_IMPORTED_MODULE_1__components_grid_Grid___default.a,
    "hero": __WEBPACK_IMPORTED_MODULE_2__components_hero_Hero___default.a,
    "project-tablet": __WEBPACK_IMPORTED_MODULE_3__components_project_tablet_ProjectTablet___default.a,
    "project-macbook": __WEBPACK_IMPORTED_MODULE_4__components_project_macbook_ProjectMacbook___default.a,
    "contact": __WEBPACK_IMPORTED_MODULE_5__components_contact_Contact___default.a,
    "select-source": __WEBPACK_IMPORTED_MODULE_6__components_select_source_SelectSource___default.a,
    "colors": __WEBPACK_IMPORTED_MODULE_7__components_colors_Colors___default.a
  },
  data: function data() {
    return {
      activeSource: this.$root.getActiveDataSource(),
      msg: 'Styles and Components',
      heroWrapperClass: '',
      projects: this.$root.getItems(),
      sources: this.$root.getAvailableDataSources()
    };
  },


  methods: {
    onSourceChanged: function onSourceChanged(key) {
      this.$root.setActiveDataSource(key);
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tableau',
  components: {},
  data: function data() {
    return {
      msg: 'Hello Tableau!',
      vizDiv: 'vizMe'
    };
  },
  methods: {
    initViz: function initViz() {
      var containerDiv = document.getElementById(this.vizDiv);
      var url = 'https://public.tableau.com/views/Technologies_0/Sheet1?:embed=y&:display_count=yes&publish=yes';
      var viz = new tableau.Viz(containerDiv, url);
    }
  },
  created: function created() {}
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_project_testimonial_ProjectTestimonial__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_project_testimonial_ProjectTestimonial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_project_testimonial_ProjectTestimonial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Testimonials',
  components: {
    'project-testimonial': __WEBPACK_IMPORTED_MODULE_1__components_project_testimonial_ProjectTestimonial___default.a
  },
  data: function data() {
    return {
      msg: 'I have had the priveledge to work with incredible people',
      items: [],
      errors: []
    };
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/static/data/projects.json').then(function (response) {
      _this.items = response.data.items;
    }).catch(function (e) {
      _this.errors.push(e);
    });
  },


  methods: {}
});

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(61)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(90),
  /* scopeId */
  "data-v-7652c016",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(79),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(81),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(89),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(87),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(94),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(85),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(91),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(83),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(59)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(82),
  /* scopeId */
  "data-v-279a386a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(93),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(58)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(77),
  /* scopeId */
  "data-v-06604693",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "parent project_item--display-testimony"
  }, [_c('article', {
    staticClass: "container"
  }, [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), (_vm.items && _vm.items.length) ? _c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', [(item.testimonial[0].quote) ? [_c('h2', [_vm._v(_vm._s(item.client))]), _vm._v(" "), _c('project-testimonial', {
      attrs: {
        "id": item.id,
        "link": item.testimonial[0].link,
        "quote": item.testimonial[0].quote,
        "name": item.testimonial[0].name,
        "role": item.testimonial[0].role
      }
    })] : void 0], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.errors && _vm.errors.length) ? _c('ul', _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v("\n                " + _vm._s(error.message) + "\n            ")])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', _vm._l((_vm.projects), function(project) {
    return _c('article', {
      staticClass: "project_items",
      class: project.class,
      attrs: {
        "id": project.id
      }
    }, [_c('project-item', {
      attrs: {
        "project": project
      }
    })], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_form--group"
  }, [(_vm.finished === false) ? _c('vue-form', {
    staticClass: "contact_form",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('validate', {
    staticClass: "field",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "input",
    attrs: {
      "id": "name",
      "type": "text",
      "name": "name",
      "placeholder": "Hello! My name is",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "auto-label": "",
      "name": "name",
      "show": "$touched || $submitted"
    }
  }, [_c('div', [_vm._v("Nice to meet you, " + _vm._s(_vm.model.name))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Let me know how to address you.")])])], 1), _vm._v(" "), _c('validate', {
    staticClass: "field",
    class: _vm.fieldClassName(_vm.formstate._replyto),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model._replyto),
      expression: "model._replyto"
    }],
    staticClass: "input",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "Email",
      "name": "_replyto",
      "required": ""
    },
    domProps: {
      "value": (_vm.model._replyto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "_replyto", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "auto-label": "",
      "name": "_replyto",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Email is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "email"
    },
    slot: "email"
  }, [_vm._v("Email is not valid")])])], 1), _vm._v(" "), _c('validate', {
    staticClass: "field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.message),
      expression: "model.message"
    }],
    staticClass: "textarea",
    attrs: {
      "id": "message",
      "name": "message",
      "placeholder": "What can I do for you?"
    },
    domProps: {
      "value": (_vm.model.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "message", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "_gotcha"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-large is-outlined is-primary"
  }, [_vm._v("Say Hello")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.finished === true) ? _c('div', {
    staticClass: "contact_form-finished"
  }, [_c('h3', [_vm._v("Thank you for your mail.")]), _vm._v(" "), _c('p', [_vm._v("You should hear back within 24 hours. While you wait, here's a great clip to demonstrate the famous Edison Quote, “I have not failed. I've just found 10,000 ways that won't work.”")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Let's work together and discover the 10,001"), _c('sup', [_vm._v("st")]), _vm._v(" way that works. I'm looking forward to it.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('iframe', {
    attrs: {
      "width": "853px",
      "height": "480px",
      "src": "https://www.youtube.com/embed/Awf45u6zrP0",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
}]}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ipad",
    style: ({
      'background-image': 'url(' + _vm.image + ')'
    })
  }, [_c('img', {
    attrs: {
      "src": "/static/base/ipad-frame.png",
      "alt": 'iPad with ' + _vm.name + ' image on the screen.'
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "notification is-info"
  }, [_vm._v("First column")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "notification is-success"
  }, [_vm._v("Second column")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "notification is-warning"
  }, [_vm._v("Third column")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "notification is-danger"
  }, [_vm._v("Fourth column")])])]), _vm._v(" "), _c('article', {
    staticClass: "example-fill columns is-multiline",
    attrs: {
      "id": "grid"
    }
  }, [_c('div', {
    staticClass: "column is-three-quarters"
  }, [_c('p', [_c('code', {
    staticClass: "html"
  }, [_vm._v("is-three-quarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Auto")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Auto")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-10 is-offset-1"
  }, [_c('p', [_c('code', [_vm._v("is-10 is-offset-1")])])])]), _vm._v(" "), _c('article', {
    staticClass: "example-fill columns",
    attrs: {
      "id": "offsetEx"
    }
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('p', [_c('code', [_vm._v("is-half is-offset-one-quarter")])])])]), _vm._v(" "), _c('article', {
    staticClass: "example-fill columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-8"
  }, [_c('p', [_c('code', [_vm._v("is-4 is-offset-8")])])])]), _vm._v(" "), _c('article', {
    staticClass: "example-fill columns",
    attrs: {
      "id": "multiline"
    }
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('p', [_c('code', [_vm._v("is-one-quarte")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('p', [_c('code', [_vm._v("is-one-quarter")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('p', [_c('code', [_vm._v("is-one-quarter")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('p', [_c('code', [_vm._v("is-one-quarter")])])])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical is-8"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child notification is-primary"
  }, [_c('p', {
    staticClass: "global_title"
  }, [_vm._v("Vertical...")]), _vm._v(" "), _c('p', {
    staticClass: "global_subtitle"
  }, [_vm._v("Top tile")])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child notification is-warning"
  }, [_c('p', {
    staticClass: "global_title"
  }, [_vm._v("...tiles")]), _vm._v(" "), _c('p', {
    staticClass: "global_subtitle"
  }, [_vm._v("Bottom tile")])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification is-info"
  }, [_c('p', {
    staticClass: "global_title"
  }, [_vm._v("Middle tile")]), _vm._v(" "), _c('p', {
    staticClass: "global_subtitle"
  }, [_vm._v("With an image")]), _vm._v(" "), _c('figure', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": "http://bulma.io/images/placeholders/640x480.png"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification is-danger"
  }, [_c('p', {
    staticClass: "global_title"
  }, [_vm._v("Wide tile")]), _vm._v(" "), _c('p', {
    staticClass: "global_subtitle"
  }, [_vm._v("Aligned with the right tile")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification is-success"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "global_title"
  }, [_vm._v("Tall tile")]), _vm._v(" "), _c('p', {
    staticClass: "global_subtitle"
  }, [_vm._v("With even more content")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  })])])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "parent"
  }, [_c('article', {
    staticClass: "container"
  }, [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('p', [_vm._v("A little insight in to \"How I Work\". These are components rendered on the same page for easy reference.\n                Bonus! Quick UI check at breakpoints for the entire site in one place.")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('article', {
    staticClass: "container"
  }, [_vm._m(2), _vm._v(" "), _c('colors')], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('article', {
    staticClass: "container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('contact')], 1)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "container animation--iPad"
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('hero', {
    attrs: {
      "heroClass": "bc"
    }
  }), _vm._v(" "), _c('hero', {
    attrs: {
      "heroClass": "default"
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('article', {
    staticClass: "container",
    attrs: {
      "id": "layouts"
    }
  }, [_vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('aside', [_c('h2', [_vm._v("Select A Source")]), _vm._v(" "), _c('select-source', {
    attrs: {
      "activeSource": _vm.activeSource,
      "sources": _vm.sources
    },
    on: {
      "source-changed": _vm.onSourceChanged
    }
  })], 1)]), _vm._v(" "), _c('project-items', {
    attrs: {
      "projects": _vm.projects
    }
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('article', {
    staticClass: "container"
  }, [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', [_vm._v("For other cool stuff that you can do with a styleguide, check out the "), _c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 3500
      }),
      expression: "{ duration: 3500}"
    }],
    attrs: {
      "href": "#layouts"
    }
  }, [_vm._v("Layout Options")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "radio",
    attrs: {
      "for": "one"
    }
  }, [_vm._v("From June 2017 in "), _c('a', {
    attrs: {
      "href": "https://goo.gl/maps/U85xFTNvxgn"
    }
  }, [_vm._v("Langland Bay")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heroWrapperClass),
      expression: "heroWrapperClass"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "wales"
    },
    domProps: {
      "checked": _vm._q(_vm.heroWrapperClass, "wales")
    },
    on: {
      "change": function($event) {
        _vm.heroWrapperClass = "wales"
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "radio",
    attrs: {
      "for": "two"
    }
  }, [_vm._v("My son as a toddler on a hill\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heroWrapperClass),
      expression: "heroWrapperClass"
    }],
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "bc"
    },
    domProps: {
      "checked": _vm._q(_vm.heroWrapperClass, "bc")
    },
    on: {
      "change": function($event) {
        _vm.heroWrapperClass = "bc"
      }
    }
  })])]), _vm._v(" "), _c('h3', [_vm._v("You're viewing: " + _vm._s(_vm.heroWrapperClass))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "typography"
    }
  }, [_c('h1', {
    attrs: {
      "id": "headings"
    }
  }, [_vm._v("Headings")]), _vm._v(" "), _c('h1', [_vm._v("h1. Heading")]), _vm._v(" "), _c('h2', [_vm._v("h2. Heading")]), _vm._v(" "), _c('h3', [_vm._v("h3. Heading")]), _vm._v(" "), _c('h4', [_vm._v("h4. Heading")]), _vm._v(" "), _c('h5', [_vm._v("h5. Heading")]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "paragraph"
    }
  }, [_vm._v("Paragraph")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, "), _c('a', {
    attrs: {
      "href": "#",
      "title": "test link"
    }
  }, [_vm._v("test link")]), _vm._v(" adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl. Praesent mattis, massa quis luctus fermentum, turpis mi volutpat justo, eu volutpat enim diam eget metus. Maecenas ornare tortor. Donec sed tellus eget sapien fringilla nonummy. Mauris a ante. Suspendisse quam sem, consequat at, commodo vitae, feugiat in, nunc. Morbi imperdiet augue quis tellus.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, "), _c('em', [_vm._v("emphasis")]), _vm._v(" consectetuer adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl. Praesent mattis, massa quis luctus fermentum, turpis mi volutpat justo, eu volutpat enim diam eget metus. Maecenas ornare tortor. Donec sed tellus eget sapien fringilla nonummy. Mauris a ante. Suspendisse quam sem, consequat at, commodo vitae, feugiat in, nunc. Morbi imperdiet augue quis tellus.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("Colors")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Color Variables")]), _vm._v(" "), _c('p', [_vm._v("Note the background color and invert color used for text.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("Contact")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Contact Component")]), _vm._v(" "), _c('p', [_vm._v("Section layout will depend on parent. "), _c('code', [_vm._v("class=\"contact\"")]), _vm._v(" will set the width and layout on the landing page. Without the contact container, form responds as seen:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("Animations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "container"
  }, [_c('header', [_c('h1', [_vm._v("iPad Animated Background**")]), _vm._v(" "), _c('p', [_vm._v("Revisiting this: CSS Keyframe is a crab.")])]), _vm._v(" "), _c('div', {
    staticClass: "component_usage"
  }, [_c('p', [_vm._v("Based on the animation property in the media object. I "), _c('a', {
    attrs: {
      "href": "https://github.com/lesliedoherty/portfolio/commit/853a10b4fcda03f7322ae8d0f145a181dd4a64ac"
    }
  }, [_vm._v("decided")]), _vm._v(" to make use of "), _c('code', [_vm._v("transform: rotateZ(360deg)")]), _vm._v(" to use the GPU power more than the CPU since it was running high at ~40% in Chrome.\n            ")]), _vm._v(" "), _c('p', [_vm._v("The conditional is used inside the for project loop.\n                "), _c('code', [_vm._v("\n                    v-if=\"project.media.animation\"\n                ")])]), _vm._v(" "), _c('p', [_vm._v("Next we evaluate the kind of animation frame we are using:\n                "), _c('code', [_vm._v("\n                    v-if=\"project.media.animation.frame === 'iPad'\n                ")])]), _vm._v(" "), _c('p', [_vm._v("Finally we pass the correct props to the component:\n                "), _c('code', [_vm._v("\n                    :image=\"project.media.animation.image\"\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("Hero Component* Needs review")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "container"
  }, [_c('header', [_c('h1', [_vm._v("Hero Component")]), _vm._v(" "), _c('p', [_vm._v("Originally had two backgrounds I couldn't decide between: ")])]), _vm._v(" "), _c('div', {
    staticClass: "component_usage"
  }, [_c('p', [_vm._v("Based on the class used when embedding the component.")]), _vm._v(" "), _c('p', [_vm._v("Pass in the following when used to see the picture from Wales (used above the router view so on all pages at the top):\n                "), _c('code', [_vm._v("\n                    class=\"wales\"\n                ")])]), _vm._v(" "), _c('p', [_vm._v("I used a dark background placeholder for the swing photo for now:\n                "), _c('code', [_vm._v("\n                    class=\"bc\"\n                ")])]), _vm._v(" "), _c('p', [_vm._v("Or for the Old Photo Of Me:\n                "), _c('code', [_vm._v("\n                    class=\"default\"\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("Project Item Layouts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Layout Classes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component_usage"
  }, [_c('p', [_vm._v("Classes are passed in with the data for each project as part of the JSON Schema for projectItem. The following classes and results are available and demonstrated:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleguide__break"
  }, [_c('h1', [_vm._v("In Progress")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Testing Hero Backgrounds")]), _vm._v(" "), _c('h2', [_vm._v("IN PROGRESS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Pick a class to change the hero background."), _c('br'), _vm._v(" "), _c('small', [_vm._v("Coming Soon: Write up of vue and styleguides to help clients and designers visualize in the browser like this.")])])
}]}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project_item"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "project_item--body"
  }, [_c('h4', {
    staticClass: "project_anchor project_item--name",
    attrs: {
      "data-anchor-id": _vm.project.id
    }
  }, [_vm._v("\n            " + _vm._s(_vm.project.name) + "\n          ")]), _vm._v(" "), _c('table', {
    staticClass: "project_item--details"
  }, [_c('caption', {
    staticClass: "sr-only"
  }, [_vm._v("Project Technical Details")]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "project_item--details__label",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('td', {
    staticClass: "project_item--details__client"
  }, [_vm._v(_vm._s(_vm.project.client))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "project_item--details__label",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Role")]), _vm._v(" "), _c('td', {
    staticClass: "project_item--details__role"
  }, [_vm._v(_vm._s(_vm.project.role))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "project_item--details__label",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Tech")]), _c('td', {
    staticClass: "project_item--details__tech"
  }, _vm._l((_vm.project.technology), function(item) {
    return _c('span', {
      key: item
    }, [_vm._v(_vm._s(item) + ", ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "project_item--content"
  }, [(_vm.project.description) ? _c('project-item-description-item', {
    attrs: {
      "label": "Description",
      "content": _vm.project.description
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project.challenges) ? _c('project-item-description-item', {
    attrs: {
      "label": "Challenges",
      "content": _vm.project.challenges
    }
  }) : _vm._e(), _vm._v(" "), (_vm.project.solution) ? _c('project-item-description-item', {
    attrs: {
      "label": "Solution",
      "content": _vm.project.solution
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.project.media.animation) ? [(_vm.project.media.animation.frame === 'iPad') ? _c('div', {
    staticClass: "project_item--preview"
  }, [_c('div', {
    staticClass: "container project_item--preview-item animation--iPad"
  }, [_c('project-tablet', {
    attrs: {
      "image": _vm.project.media.animation.image,
      "name": _vm.project.name
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.project.media.animation.frame === 'macbook') ? _c('div', {
    staticClass: "project_item--preview"
  }, [_c('div', {
    staticClass: "container project_item--preview-item animation--macbook"
  }, [_c('project-macbook', {
    attrs: {
      "image": _vm.project.media.animation.image,
      "name": _vm.project.name
    }
  })], 1)]) : _vm._e()] : (_vm.project.media.preview) ? [(_vm.project.media.preview) ? _c('div', {
    staticClass: "project_item--preview"
  }, [_c('img', {
    staticClass: "project_item--preview-item",
    attrs: {
      "src": _vm.project.media.preview,
      "alt": 'Image of project with ' + _vm.project.name
    }
  })]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm.project.testimonial[0]) ? [_c('project-testimonial', {
    attrs: {
      "id": _vm.project.id,
      "link": _vm.project.testimonial[0].link,
      "quote": _vm.project.testimonial[0].quote,
      "name": _vm.project.testimonial[0].name,
      "role": _vm.project.testimonial[0].role,
      "image": _vm.project.testimonial[0].image
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container hero header",
    class: _vm.heroClass,
    attrs: {
      "id": "a11y"
    }
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/base/The-SnapBar-Me_Owen.png",
      "alt": "my son on my back holding a sign that says Data Fam"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-body"
  }, [_c('h2', {
    staticClass: "anchor",
    attrs: {
      "data-anchor-id": "a11y"
    }
  }, [_vm._v("\n      Front-end architect\n      "), _c('span', [_vm._v("and accessibility developer")])]), _vm._v(" "), _c('p', [_vm._v("Lead Accessibility Engineer at Tableau marketing. Helped established the Tableau marketing accessibility program in\n      2018.")]), _vm._v(" "), _c('p', [_vm._v("Read about "), _c('a', {
    attrs: {
      "href": "http://bit.ly/bringing-a11y",
      "target": "_blank"
    }
  }, [_vm._v("how I brought accessibility to Tableau marketing "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("launches medium app in a new window")])]), _vm._v(", and the data visualization tools I used to\n      "), _c('a', {
    attrs: {
      "href": "http://bit.ly/tableau-a11y",
      "target": "_blank"
    }
  }, [_vm._v("identify quick accessibility wins "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("launches medium app in a new window")])]), _vm._v(".")])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-wrap"
  }, [_c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "nav_links"
  }, [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 4000
      }),
      expression: "{ duration: 4000}"
    }],
    staticClass: "nav_item",
    attrs: {
      "href": "#a11y"
    }
  }, [_vm._v("Accessibility")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 4000
      }),
      expression: "{ duration: 4000}"
    }],
    staticClass: "nav_item",
    attrs: {
      "href": "#mission"
    }
  }, [_vm._v("Mission")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 4000
      }),
      expression: "{ duration: 4000}"
    }],
    staticClass: "nav_item",
    attrs: {
      "href": "#projects"
    }
  }, [_vm._v("Projects")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 4000
      }),
      expression: "{ duration: 4000}"
    }],
    staticClass: "nav_item",
    attrs: {
      "href": "#contact"
    }
  }, [_vm._v("Contact")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "nav_branding content"
  }, [_c('h1', {
    staticClass: "global_title"
  }, [_vm._v("Leslie Doherty")])])
}]}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "skip"
  }, [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 1000,
        offset: -50
      }),
      expression: "{ duration: 1000, offset: -50 }"
    }],
    staticClass: "skip--anchor",
    attrs: {
      "href": "#a11y"
    }
  }, [_vm._v("Skip Navigation")])]), _vm._v(" "), _c('app-navigation'), _vm._v(" "), _c('main', {
    staticClass: "content",
    attrs: {
      "role": "main"
    }
  }, [_c('hero'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    domProps: {
      "value": _vm.activeSource
    },
    on: {
      "change": _vm.sourceChanged
    }
  }, _vm._l((_vm.sources), function(source, id) {
    return _c('option', {
      domProps: {
        "value": id
      }
    }, [_vm._v(_vm._s(source.name))])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container project_item--testimonial-wrapper"
  }, [_c('img', {
    staticClass: "testimonial_image",
    attrs: {
      "src": _vm.image,
      "alt": 'Photo of ' + _vm.name
    }
  }), _vm._v(" "), _c('blockquote', {
    key: _vm.id,
    staticClass: "project_item--testimonial",
    attrs: {
      "cite": _vm.link
    }
  }, [_vm._v("\n        " + _vm._s(_vm.quote) + "\n        "), _c('cite', [_c('a', {
    staticClass: "testimonial_name",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Opens in linkedIn page in a new tab for ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('span', {
    staticClass: "testimonial_role"
  }, [_vm._v(_vm._s(_vm.role))])])])])
},staticRenderFns: []}

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project_item--content-wrap",
    class: 'project_item--content__' + _vm.label
  }, [_c('h5', [_vm._v(_vm._s(_vm.label) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.content))])])
},staticRenderFns: []}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "columns is-multiline",
    attrs: {
      "id": "colors"
    }
  }, _vm._l((_vm.colorVars), function(color) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('div', {
      staticClass: "colors",
      class: 'is-' + color.name
    }, [_c('h2', [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('p', [_vm._v("Variable: "), _c('code', {
      staticClass: "html"
    }, [_vm._v(_vm._s(color.var))])]), _vm._v(" "), _c('p', [_vm._v("Invert: "), _c('code', {
      staticClass: "html"
    }, [_vm._v(_vm._s(color.invert))])])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "featured background-purple",
    attrs: {
      "id": "mission"
    }
  }, [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "container padding-top__none"
  }, [_c('p', [_vm._v("I prefer to work in a collaborative environment with a team that shares a purpose. My career has always\n        centered around empowering people, even as I pursued a masters degree and career in tech. I believe it is possible to obtain both by pursuing a career in accessibility.")]), _vm._v(" "), _c('blockquote', [_vm._v("By putting accessibility first, we not only produce better code, but find a purpose for doing so.")]), _vm._v(" "), _c('p', [_vm._v("My mission is to join with others who want more out of a career. I partner with people who combine corporate priorities\n    with the people that support them, who seek to empower users of all abilities, and who choose compassion over competition. If you are looking for someone like me, "), _c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 4000
      }),
      expression: "{ duration: 4000}"
    }],
    attrs: {
      "href": "#contact"
    }
  }, [_vm._v("I'd love to chat.")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "projects"
    }
  }, [_vm._m(1), _vm._v(" "), _c('project-items', {
    attrs: {
      "projects": _vm.projects
    }
  })], 1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "container global_title--section-main"
  }, [_c('h3', {
    staticClass: "anchor global_subtitle upper",
    attrs: {
      "data-anchor-id": "mission"
    }
  }, [_vm._v("Mission")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-indigo"
  }, [_c('header', {
    staticClass: "container global_title--section-main"
  }, [_c('h3', {
    staticClass: "anchor upper global_subtitle soft-gray",
    attrs: {
      "data-anchor-id": "projects"
    }
  }, [_vm._v("Recent Projects")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contact",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "background-purple"
  }, [_c('header', {
    staticClass: "container global_title--section-main"
  }, [_c('h3', {
    staticClass: "anchor global_subtitle upper",
    attrs: {
      "data-anchor-id": "contact"
    }
  }, [_vm._v("Get In Touch")])]), _vm._v(" "), _c('article', {
    staticClass: "container padding-top__none"
  }, [_c('ul', {
    staticClass: "contact_links"
  }, [_c('li', [_c('a', {
    staticClass: "contact_links--item",
    attrs: {
      "href": "https://github.com/lesliedoherty",
      "target": "_blank"
    }
  }, [_vm._v("\n            Github "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("link takes you to new page.")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "contact_links--item",
    attrs: {
      "href": "https://www.linkedin.com/in/leslied/",
      "target": "_blank"
    }
  }, [_vm._v("\n            LinkedIn "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(" link takes you to a new page.")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "contact_links--item",
    attrs: {
      "href": "https://twitter.com/mrsflinger",
      "target": "_blank"
    }
  }, [_vm._v("\n            Twitter "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(" link takes you to a new page with the twitter profile for @mrsflinger.")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "contact_links--item",
    attrs: {
      "href": "https://instagram.com/mrsflinger",
      "target": "_blank"
    }
  }, [_vm._v("\n            Instagram "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Link takes you to a new page.")])])])]), _vm._v(" "), _c('p', [_vm._v("I'll be incorporating a static contact form here shortly. For now, I apologize for the links to reach me elsewhere.")])])])])
}]}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "macbook",
    style: ({
      'background-image': 'url(' + _vm.image + ')'
    })
  }, [_c('img', {
    attrs: {
      "src": "/static/base/macbook-frame.png",
      "alt": 'Macbook with image of ' + _vm.name + '.'
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "parent"
  }, [_c('article', {
    staticClass: "container"
  }, [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('p', [_vm._v("I've been playing with your software and I think I've found my happy spot. I might love data visualization more than my children. I'm kidding, of course. The best thing in the world is gathering data on your children and then showing them how often they forget to feed the dog. Graphs are the new parenting tactic.")]), _vm._v(" "), _c('p', [_vm._v("I'm using vue for my portfolio and got the tableu api set up but I have an error that google was very unhelpful with. ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("I believe it's something about the canvas / object and way vue renders. I'll revisit this shortly because I'm now determined to figure it out. Also, in the spirit of \"done and not perfect\" and \"agile\" and \"transparency\" and \"fail fast\" and \"All The Chilches,\" here's a downloaded image of the data I played with and a link to the public worksheet. I plan on doing much, much more with this.")]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("\"Viz resize limit hit. The calculated iframe size did not stabilize after 10 resizes.\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://public.tableau.com/views/Technologies_0/Sheet1?:embed=y&:display_count=yes&publish=yes"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/base/tableauTech.png",
      "alt": "DATA Visualization is The Most Fun"
    }
  })])])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer",
    attrs: {
      "role": "contentinfo"
    }
  }, [_c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer_misc"
  }, [_c('h4', [_vm._v(" ©2020")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Please do kindly tell me how I can improve my code.")]), _vm._v(" "), _c('li', [_vm._v("As always, this is a work in progress, just like I am.")]), _vm._v(" "), _c('li', [_vm._v("If you find accessible bugs, please "), _c('a', {
    attrs: {
      "href": "https://github.com/lesliedoherty/portfolio/issues"
    }
  }, [_vm._v("feel free to create an issue on github "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("in a new window")])]), _vm._v(" .")])])])])])
}]}

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[39]);


// WEBPACK FOOTER //
// static/js/app.4a7313357d990eadc386.js